<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-rebrand" novalidate>
  <fieldset class="form--fieldset">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-6 col-xl-5">
        <label for="cardholderName" class="form-label">
          <sup>*</sup> Cardholder&rsquo;s name
        </label>
        <input class="inspectletIgnore form-control form-control-lg" type="text" id="cardHolderName" formControlName="cardHolderName"
               placeholder="e.g. John Smith">
        <div *ngIf="form.get('cardHolderName').invalid && (form.get('cardHolderName').touched || formSubmitted)" class="alert-container">
          <div class="alert alert-danger" role="alert" yp-e2e-id="card-name-alert">Please enter the
            cardholder&rsquo;s name.
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">

      </div>
    </div>
  </fieldset>
  <fieldset class="form--fieldset mt-3">
    <div class="row">
      <div class="col-sm-10 col-md-8 col-lg-7">
        <label for="card-element" class="form-label">
          <sup>*</sup> Credit or debit card
        </label>
        <div id="card-element" [class]="{'error-message': stripeErrorMessage}">
          <!-- A Stripe Element will be inserted here. -->
        </div>
        <div *ngIf="stripeErrorMessage" class="alert-container">
          <div class="alert alert-danger"
               role="alert"
               yp-e2e-id="card-error-message">{{stripeErrorMessage}}
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-8 col-lg-7 mt-2">
        <span (click)="showCardCvcInfo()" class="where-can-find-it">Where can I find my CVC?</span>
        <div *ngIf="cvcInfo" class="where-can-find-it-content">
          <div class="cvv-icon"></div>
          <span>Your CVC number is usually the last 3 digits on the back of your card.</span>
        </div>
      </div>
    </div>
  </fieldset>

  <!--New stuff-->
  <article class="terms-and-conditions-block mt-3">
    <div class="row">
      <div class="col-xs-12">
        <fieldset>
          <div class="form-check form-check-small form-check-inline">

            <input type="checkbox" id="termsAndConditions" formControlName="termsAndConditions" class="form-check-input">
            <label for="termsAndConditions" class="form-check-label">
              Please read the general
              <a href="/terms-and-conditions" title="Terms &amp; conditions"
                 target="_blank" id="termsAndConditionsLink">terms &amp; conditions</a>.
              By clicking &lsquo;pay now&rsquo; you confirm you agree to be bound by these terms.
            </label>
          </div>
          <div *ngIf="form.get('termsAndConditions').invalid && formSubmitted" class="alert-container">
            <div class="alert alert-danger" role="alert" yp-e2e-id="pay-now-tndc-alert">
              You must agree to our terms &amp; conditions.
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </article>
  <!--End new stuff-->

  <button [appButtonLoader]="paymentLoading" type="submit" class="button button-primary mt-3">Pay now</button>
</form>
